import { JobNotificationCardModel } from '../job-notification-card.model';

export class DocoonInboundFlowNotificationCardModel extends JobNotificationCardModel {
  // A succeeded check may bring nothing new: the lists, not the status, tell.
  public newDocumentExistenceFlag = false;
  public purchaseCreditUuids: string[] = [];
  public purchaseInvoiceUuids: string[] = [];
}
